/**
 * Intersection Observer for scroll animations
 */
export function observeElements() {
	if (typeof window === 'undefined') return;
	
	const options = {
		root: null,
		rootMargin: '0px',
		threshold: 0.1
	};
	
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('animate-in');
				// Optional: unobserve after animation
				// observer.unobserve(entry.target);
			}
		});
	}, options);
	
	// Observe all elements with data-animate attribute
	document.querySelectorAll('[data-animate]').forEach(el => {
		observer.observe(el);
	});
	
	return observer;
}

/**
 * Add stagger animation to children
 */
export function staggerChildren(container: HTMLElement, delay = 100) {
	const children = container.children;
	
	Array.from(children).forEach((child, index) => {
		(child as HTMLElement).style.animationDelay = `${index * delay}ms`;
	});
}

/**
 * Parallax scrolling effect
 */
export function parallax(element: HTMLElement, speed = 0.5) {
	if (typeof window === 'undefined') return;
	
	const updateParallax = () => {
		const scrolled = window.pageYOffset;
		const yPos = -(scrolled * speed);
		element.style.transform = `translateY(${yPos}px)`;
	};
	
	window.addEventListener('scroll', updateParallax);
	
	// Return cleanup function
	return () => {
		window.removeEventListener('scroll', updateParallax);
	};
}

/**
 * Counter animation for numbers
 */
export function animateCounter(
	element: HTMLElement,
	target: number,
	duration = 2000,
	suffix = ''
) {
	const start = 0;
	const increment = target / (duration / 16); // 60 FPS
	let current = start;
	
	const timer = setInterval(() => {
		current += increment;
		if (current >= target) {
			current = target;
			clearInterval(timer);
		}
		element.textContent = Math.floor(current).toLocaleString() + suffix;
	}, 16);
	
	return () => clearInterval(timer);
}